function toRoundedInt(value) {
    if (!Number.isFinite(value)) return undefined;
    const rounded = Math.round(value);
    return rounded >= 0 ? rounded : undefined;
}

export function buildInputProof(event, options = {}) {
    const kind = options.kind === 'drag' ? 'drag' : 'click';
    const trusted = !!event?.isTrusted;
    const timestamp = Date.now();

    const durationMs = toRoundedInt(options.durationMs);
    const distancePx = toRoundedInt(options.distancePx);

    const proof = {
        v: 1,
        kind,
        trusted,
        ts: timestamp
    };

    if (durationMs !== undefined) proof.dur_ms = durationMs;
    if (distancePx !== undefined) proof.dist_px = distancePx;

    return proof;
}
